<template>
    <div>
        <correction-write-link v-for="writeLayout in writeLayouts" :key="`correctionComp${writeLayout}`"
                               :writeLayout="writeLayout" :correctionData="correctionData"></correction-write-link>
    </div>
</template>

<script>
import CorrectionWriteLink from "@/components/correction/CorrectionWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import correctionValidator from "@/mixins/validators/correctionValidator";
import elFileMixins from "@/mixins/elFileMixins";
import correctionUtil from "@/components/correction/correctionUtil";

export default {
    name: "CorrectionWriteComponent",
    mixins: [alertMixins, correctionUtil, correctionValidator, elFileMixins],
    components: {CorrectionWriteLink},
    inject: ['changeLoading'],
    provide() {
        return {
            correctionWriteSetData: this.setData,

        }
    },
    props: {
        correctionType: {},
        correctionKey: {default: 0},
    },
    data() {
        return {
            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            fileType: '',
            getFunc: '',
            detailApiParamsSet: {},
            correctionData: {},
            date: '',
            be_end: 0,
            r_idx: ''

            //필터
        }
    },
    created() {
        this.initFilterConfig();
        if (this.correctionKey === 0) {
            this.initTemplateConfig();
        } else {
            // api가 연결 된다면 실행되는 메소드입니다.
            this.getCorrection();
        }
    },
    mounted() {
        EventBus.$on('writeCorrection', this.writeCorrection);

    },
    beforeDestroy() {
        EventBus.$off('writeCorrection');

    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        initTemplateConfig() {
            let configCorrection = this.returnCorrectionConfig(this.correctionType);
            this.writeLayouts = configCorrection.writeLayouts;
        },
        initFilterConfig() {
            let configCorrection = this.returnCorrectionConfig(this.correctionType);
            this.writeFunc = configCorrection.writeFunc;
            this.writeApiParamSet = configCorrection.writeApiParamSet;
            this.parsingData = configCorrection.parsingData;
            this.getFunc = configCorrection.getFunc;
            this.detailApiParamsSet = configCorrection.detailApiParamsSet;
            this.directUrl = configCorrection.directUrl;
            this.directType = configCorrection.directType;
            this.keyName = configCorrection.keyName;
            this.fileType = configCorrection.fileType;
            this.writeSuccessType = configCorrection.writeSuccessType;
            this.writeFailTypes = configCorrection.writeFailTypes;
        },
        getCorrection() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            !util.isEmpty(this.keyName) ? params[this.keyName] = this.correctionKey : params.id = this.correctionKey;
            this.$api.$correction[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 && res.List.length === 0) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.correctionData = res.List[0];
                this.initTemplateConfig();
            })
        },
        writeCorrection() {
            let dataArr = ['title', 'content']


            if(!util.isEmpty(this.files)) {
                dataArr = ['title'];
            }
            /*if (util.isEmpty(this.deleteFiles) && !util.isEmpty(this.correctionData.Reply.List)) {
                this.files = this.correctionData.Reply.List[0].File;
            }*/
            this.$validate(dataArr).then(success => {
                if (!success) {
                    this.errorAlert('필수정보를 모두 입력해주세요.');
                    return;
                }
                this.changeLoading(true);
                let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
                dataArr = Object.keys(this.parsingData);
                dataArr.forEach(dataKey => {
                    params[this.parsingData[dataKey]] = this[dataKey];
                });
                //원글 번호
                params.r_parent = this.correctionKey;
                //params.r_is_file = this.correctionData.r_is_file;
                //수정일 경우 해당 글의 r_idx layout에서 initset으로 보내주는데이터입니다.
                if (!util.isEmpty(this.r_idx)) {
                    params.r_idx = this.r_idx
                }
                let checkFile = !util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0;
                if (checkFile) {
                    params.r_text_number = 1;
                }
                if(util.isEmpty(this.files)) {
                    params.r_is_file = 0;
                }else{
                    params.r_is_file = 1;
                }
                try {
                    this.$api.$correction[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnCorrectionType(res.Info.type);
                        if (type != true) {
                            this.changeLoading(false);
                            this.errorAlert(type);
                            return false;
                        }
                        //파일 삭제
                        if(!util.isEmpty(this.deleteFiles)) {
                            this.removeFiles(this.deleteFiles);
                        }
                        //일반 이미지
                        if (checkFile) {
                            this.uploadFiles(this.files, 'repair', res.List.r_idx).then(success => {
                                if(success){
                                    this.afterFunc(res.List.r_idx);
                                }else{
                                    this.errorAlert('파일 업로드 실패');
                                    return false;
                                }
                            });
                        } else {
                            this.afterFunc(res.List.r_idx);
                        }
                    });

                } catch (e) {
                    this.changeLoading(false);
                    console.log(e);
                }
            })
        },

        returnCorrectionType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? '저장에 실패하였습니다.' : this.writeFailTypes[type]
            }
        },
        afterFunc(key) {
            this.changeLoading(false);
            if (this.correctionKey != 0) {
                EventBus.$emit('correctionListUpdateAfterFunc', this.keyName, Number(this.correctionKey));
            } else {
                EventBus.$emit('correctionListAddAfterFunc');
            }
            let detailKey = key;
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.deleteFiles = [];
                        this.getCorrection();
                        return false;
                    }
                    let url = this.directUrl;
                    if (this.directType === 'detail') {
                        url = url + detailKey;
                    }
                    this.$router.push(url);
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
